import React from 'react';
import { motion } from 'framer-motion';

interface PreloadingScreenProps {
  count: number;
  total: number;
}

const PreloadingScreen: React.FC<PreloadingScreenProps> = ({ count, total }) => {
  const progress = total > 0 ? Math.floor((count / total) * 100) : 0;

  return (
    <div className="preloading-screen" role="status" aria-live="polite">
      <div className="preloading-orb" aria-hidden="true">
        <span className="equalizer equalizer--lg">
          <span />
          <span />
          <span />
          <span />
          <span />
        </span>
      </div>

      <h2>Preparing the playlist</h2>
      <p className="muted">
        {count} of {total} songs ready
      </p>

      <div className="progress-bar progress-bar--lg">
        <motion.div
          className="progress-fill"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ ease: 'easeOut', duration: 0.5 }}
        />
      </div>
      <span className="progress-pct">{progress}%</span>

      <p className="muted small">The game starts automatically once every song is loaded.</p>
    </div>
  );
};

export default PreloadingScreen;
